export default function canUseBridge(name) {
    if (!window.kwaiying || !window.kwaiying[name]) {
        return false;
    }
    return true;
}
